import { useOutletContext } from 'react-router-dom';

/**
 * What the Books shell hands to whichever tab is open. The range lives in the
 * URL, but tabs read it from here rather than parsing the query string
 * themselves — one owner, so a tab can't disagree with the picker above it.
 */
export type BooksOutletContext = {
    /** ISO `YYYY-MM-DD`. */
    fromDate: string;
    toDate: string;
    /**
     * Move the shell's window (BOS-166). A tab needs this to offer a widen from
     * its own empty state, and to open on the period it is *about* — the VAT
     * report is a statement about last month whatever the shell happens to
     * show. `undefined` when the tab renders outside the shell, in which case
     * there is no window to move and no offer to make.
     */
    onRangeChange?: (from: string, to: string) => void;
};

/** The shell's range, or an empty one when a tab is rendered outside it. */
const NO_RANGE: BooksOutletContext = { fromDate: '', toDate: '' };

export const useBooksRange = (): BooksOutletContext =>
    useOutletContext<BooksOutletContext | null>() ?? NO_RANGE;
